<div style="margin-bottom: 10px" *ngIf="headline">{{ headline }}</div>

<div class="fundracer-froala" [class.is-white]="isWhite" [froalaEditor]="options" [formControl]="editorControl"></div>
